'use client';
import Image from '@repo/ui/src/components/Image';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps, LinkProps } from '@repo/ui/src/types';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useCurrentUrl from '../../hooks/useCurrentUrl';

interface LinkWithDisplayType {
  displayType: ButtonVariant;
  link: LinkProps;
}

export interface SideBySideProps {
  title?: string;
  description?: string;
  links: Array<LinkWithDisplayType>;
  image?: ImageProps;
  noPadding?: boolean;
  linkClicked?: any;
}

const SideBySide = ({
  title,
  description,
  links,
  image,
  noPadding,
  linkClicked,
}: SideBySideProps) => {
  const imgUrl = image ? buildImageSrc(image, 700) : '';
  const { locale } = useCurrentUrl();

  return (
    <div
      className={classNames(
        'grid sm:grid-cols-[3fr_2fr] gap-2 max-w-[1500px] m-auto',
        noPadding ? 'p-0' : 'p-4 md:p-20',
      )}
    >
      <div className={classNames(!noPadding && 'sm:pl-14')}>
        <ToutContent
          divider
          headingStyleVariant="h4"
          description={description}
          align="left"
          heading={title}
          tabIndex={0}
        />
        <div className="flex flex-col my-4 md:my-8 gap-4 lg:flex-row">
          {links?.map((link, index) => (
            <Button
              key={index}
              {...link?.link}
              variant={link?.displayType ?? ButtonVariant.knife}
              as={Anchor}
              onClick={() => {
                linkClicked?.({
                  affiliation: 'website',
                  brand: 'Traeger',
                  locale,
                  link_text: link?.link?.displayName,
                  link_type: 'Side by Side',
                  link_url: link?.link?.externalLink,
                });
              }}
            >
              {link?.link?.displayName}
            </Button>
          ))}
        </div>
      </div>
      <div className="mb-5 relative min-h-[200px] h-full">
        {image && <Image src={imgUrl} layout="fill" objectFit="cover" alt={image?.altTag} />}
      </div>
    </div>
  );
};

export default SideBySide;
